import { forwardRef, Ref } from 'react';
import Link from '../Atoms/Link';

import { ArrowDown } from '../Atoms/ArrowButton';

// eslint-disable-next-line react/display-name
const SellBuyDecisionDivider = forwardRef(
  (
    {
      t,
      sellingLink = '#sell',
      buyingLink = '#buy',
      wrapperClassName = 'mt-28 lg:mt-0 opacity-0 flex lg:h-screen text-center flex-col items-center justify-center will-change-opacity'
    }: {
      t: (string: string) => string,
      sellingLink?: string,
      buyingLink?: string,
      wrapperClassName?: string,
    },
    ref: Ref<HTMLDivElement>
  ) => {
    return (
      <div id="decision" data-scroll-section className={wrapperClassName} style={{ scrollSnapAlign: 'start' }} ref={ref}>
        <span className="font-cirka text-xl text-black mb-40">{t('hero.subtitle')}</span>
        <div className="grid grid-cols-2 divide-x-2 divide-primary">
          <div className="flex justify-center items-center flex-col-reverse lg:flex-col px-8">
            <span className="text-primary font-cirka text-4xl lg:text-5xl">
              {t('hero.wantToEstimate')}
              <Link to={sellingLink} className="text-blue">
                {t('hero.estimate')}
              </Link>
            </span>
            <Link to={sellingLink} className="no-animation" aria-label={t('hero.sell')}>
              <ArrowDown className="mb-4 lg:mb-0 lg:mt-10" />
            </Link>
          </div>
          <div className="flex justify-center items-center flex-col-reverse lg:flex-col px-8">
            <span className="text-primary font-cirka text-4xl lg:text-5xl">
              {t('hero.wantTo')}
              <Link to={buyingLink} className="text-blue">
                {t('hero.buy')}
              </Link>
            </span>
            <Link to={buyingLink} className="no-animation" aria-label={t('hero.buy')}>
              <ArrowDown className="mb-4 lg:mb-0 lg:mt-10" />
            </Link>
          </div>
        </div>
      </div>
    )
  })

export default SellBuyDecisionDivider;
